import React from "react";
import { Box, Link } from "@mui/material";
import Blogs from "../../data/blogs";
import { colors, fonts, layout } from "../../theme/tokens";

const BlogCards = () => {
  return (
    <Box
      component="section"
      sx={{ pt: "20px", pb: "80px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: { xs: "20px", md: "24px" },
          }}
        >
          {Blogs.map((blog) => (
            <Link
              key={blog.id}
              href={`/news/${blog.link}`}
              underline="none"
              sx={{
                display: "flex",
                flexDirection: "column",
                background: "#fff",
                border: `1px solid ${colors.lineSoft}`,
                borderRadius: "22px",
                overflow: "hidden",
                boxShadow: "0 18px 40px -32px rgba(14,27,42,.5)",
                transition: "transform .4s cubic-bezier(.2,.7,.2,1)",
                "&:hover": {
                  transform: "translateY(-6px)",
                  "& .blog-img": { transform: "scale(1.05)" },
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: { xs: "200px", md: "240px" },
                  overflow: "hidden",
                }}
              >
                <Box
                  className="blog-img"
                  component="img"
                  src={blog.image}
                  alt={blog.name}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    transition: "transform .4s ease",
                  }}
                />
              </Box>
              <Box
                sx={{
                  p: { xs: "22px", md: "28px" },
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    fontFamily: fonts.body,
                    fontSize: "13px",
                    fontWeight: 500,
                    color: colors.subtleText,
                    mb: "12px",
                  }}
                >
                  {blog.date}
                </Box>
                <Box
                  component="h3"
                  sx={{
                    fontFamily: fonts.display,
                    fontWeight: 700,
                    fontSize: { xs: "18px", md: "20px" },
                    color: colors.navyInk,
                    lineHeight: 1.3,
                    mb: "12px",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {blog.name}
                </Box>
                <Box
                  sx={{
                    fontFamily: fonts.body,
                    fontSize: "14px",
                    color: "#6A7888",
                    lineHeight: 1.6,
                    mb: "20px",
                    flexGrow: 1,
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {blog.desc[0]}
                </Box>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    fontFamily: fonts.body,
                    fontSize: "14px",
                    fontWeight: 700,
                    color: colors.steelBlue,
                  }}
                >
                  Read article <Box component="span">→</Box>
                </Box>
              </Box>
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BlogCards;
